import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedLanguagesSingle from './viewRelatedLanguagesSingle';
import viewRelatedLanguagesMulti from './viewRelatedLanguagesMulti';

export default {
  title: 'Language',
  attributeName: 'infoPages',
  helpText: '',
  fields: [
    // {
    //   attributeName: 'countryCode',
    //   helpText: 'List of Country Codes',
    //   type: FormInputTypes.SELECT,
    //   label: 'Country Code',
    //   placeholder: 'Please enter to add Country code...',
    //   multiple: true,
    //   url: 'countries',
    //   filter: 'name',
    //   asyncSelect: true,
    //   options: [],
    // },
    {
      attributeName: 'defaultLanguage',
      label: 'Default language',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedLanguagesSingle,
      default: [],
      helpText: 'Select the default language.',
      width: '30rem',
      maxElements: 1,      
      blockItemRemove: true,
      sync: {
        targetField: 'languages',
        mode: 'append-if-missing',
        compareKey: 'locale',
      },
    },
    {
      attributeName: 'languages',
      label: 'Languages',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedLanguagesMulti,
      default: [],
      helpText: 'Select the available languages.',
      width: '30rem',
    },
  ],
};